import React, {Component} from "react";
import styles from './detailBloodStationContacts.module.scss';
import DetailBloodStation from "../../../entities/detail_blood_station";
import {sendMetrics} from "../../../utils/misc";

export default class DetailBloodStationContacts extends Component<any, any> {
  props: {
    bloodStation: DetailBloodStation;
    isMobile: boolean;
  }

  constructor(props) {
    super(props);
    this.state = {
      isShowAllContacts: !props.isMobile ? true : !props.bloodStation.phone_numbers[0]
    }
  }

  showAllContacts = () => {
    this.setState({
      isShowAllContacts: !this.state.isShowAllContacts
    })
  }

  render() {
    const {props, state, showAllContacts} = this;
    const {isShowAllContacts} = state;
    const {bloodStation, isMobile} = props;
    const {email, site, phone_numbers} = bloodStation
    if ((!email && !site && !(phone_numbers.length > 0))) {
      return null
    }
    return (
      <div className={styles.Contacts}>
        <div className={styles.Contacts_Header}>
          <div className={styles.Contacts_Header_Title}>
            <h3>Контакты</h3>
          </div>
          {isMobile &&
          <div className={styles.Contacts_Header_Button}>
            {!isShowAllContacts && <span onClick={showAllContacts}>Показать все</span>}
            {isShowAllContacts && <span onClick={showAllContacts}>Скрыть все</span>}
              <img
                  className={isShowAllContacts ? styles.Contacts_Header_Button_Bottom : styles.Contacts_Header_Button_Right}
                  src="/static/images/arrows/right.svg" alt=""/>
          </div>}
        </div>
        <div className={styles.DetailBloodStationContacts}>
          {!isShowAllContacts && <PhoneItems phoneInfo={phone_numbers[0]}/>}
          {isShowAllContacts && phone_numbers.map(item => <PhoneItems key={item.id} phoneInfo={item}/>)}
          {isShowAllContacts && <BSContacts email={email} site={site}/>}
        </div>
      </div>
    )
  }
}

const PhoneItems = ({phoneInfo}) => {
  if (phoneInfo) {
    const {phone, comment} = phoneInfo
    return (
      <div className={styles.DetailBloodStationContacts_Items}>
        <span>Телефон</span>
        <a onClick={() => sendMetrics('call_bs')}
           href={'tel:' + phone}>{phone}</a>
        <span>{comment}</span>
      </div>
    )
  } else return null
}

const BSContacts = ({site, email}) => {
  return (
    <div className={styles.DetailBloodStationContacts_AdditionalContacts}>
      {site && <div className={styles.DetailBloodStationContacts_Items}>
          <span>Сайт</span>
          <a onClick={() => sendMetrics('web_bs')}
             href={site} target={'_blank'}>{site.substring(0, 30) + '...'}</a>
      </div>}
      {email && <div className={styles.DetailBloodStationContacts_Items}>
          <span>Email</span>
          <a onClick={() => sendMetrics('email_bs')}
             href={'mailto:' + email}>{email}</a>
      </div>}
    </div>
  )
}
